module.exports = __webpack_public_path__ + "static/media/synchro-watch.f79ffaed.svg";